import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Logo from '../Images/Logo.png';
import { NavLink } from "react-router-dom";


const Navbars = () => { 
  return (
    <Navbar expand="lg" className="bg-body-light navbar">
      <Container>
        <img className="img-fluid" src={Logo} alt="Logo" />

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto links">
            <Nav.Link as={NavLink} to="/" end className="nav-link-custom">
              Home
            </Nav.Link>
            <Nav.Link as={NavLink} to="/services" className="nav-link-custom">
              Services
            </Nav.Link>
            <Nav.Link as={NavLink} to="/portfolio" className="nav-link-custom">
              Portfolio
            </Nav.Link>
            <Nav.Link as={NavLink} to="/about" className="nav-link-custom">
              About
            </Nav.Link>
            <Nav.Link as={NavLink} to="/contact" className="nav-link-custom">
              Contact
            </Nav.Link>
          </Nav>
{/* 
          <div className="d-flex align-items-center ms-auto">
            <NavLink to="/start-project" end>
              {({ isActive }) => (
                <button className={`start-link ${isActive ? "active" : ""}`}>
                  Start a Project
                </button>
              )}
            </NavLink>
          </div> */}

        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navbars;
